import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import TBL_LANGUAGE from '../../constants/tblLanguage.js';
import { LOCALE, DEFAULT_LOCALE_CODE } from '../../constants';

const LANGS = LOCALE.map(l => l.code);
const resources = LANGS.reduce((acc, lang) => {
    acc[lang] = {
        translation: TBL_LANGUAGE.reduce((t, row) => {
            if (row.key != null && row[lang] != null) t[row.key] = row[lang];
            return t;
        }, {}),
    };
    return acc;
}, {});

function getDefaultLanguage() {
    const saved = localStorage.getItem('language');
    if (saved && LANGS.includes(saved)) return saved;
    const browser = typeof navigator !== 'undefined' ? (navigator.language || navigator.userLanguage || '').substring(0, 2) : '';
    return LANGS.includes(browser) ? browser : DEFAULT_LOCALE_CODE;
}

/** 앱 언어에 맞춰 document lang 설정 (접근성·네이티브 컨트롤 힌트용) */
function syncDocumentLang(lng) {
    if (typeof document === 'undefined') return;
    const locale = LOCALE.find(l => l.code === lng)?.locale || LOCALE.find(l => l.code === DEFAULT_LOCALE_CODE)?.locale || 'ko-KR';
    document.documentElement.setAttribute('lang', locale);
}

i18n.use(initReactI18next).init({
    resources,
    lng: getDefaultLanguage(),
    fallbackLng: DEFAULT_LOCALE_CODE,
    interpolation: {
        escapeValue: false,
    },
});

// 초기 로드 시 및 언어 변경 시 document lang 동기화
syncDocumentLang(i18n.language);
i18n.on('languageChanged', syncDocumentLang);

export default i18n;
